import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=f153d92a&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"
import style0 from "./EditButton.vue?vue&type=style&index=0&id=f153d92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f153d92a",
  null
  
)

export default component.exports